import {
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonRow,
  IonSkeletonText,
} from "@ionic/react";
import React from "react";

const Skeleton_OrderViewModal: React.FC = () => {
  return (
    <>
      <IonContent>
        <div style={{ margin: "13px", marginTop: "18px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "20px",
            }}
          >
            <div style={{ width: "60%" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "90%", height: "28px", marginBottom: "8px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "60%", height: "20px" }}
              />
            </div>
            <IonSkeletonText
              animated={true}
              style={{ width: "80px", height: "24px", borderRadius: "16px" }}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", gap: "2px" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "25%", height: "40px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "25%", height: "40px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "25%", height: "40px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "25%", height: "40px" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div style={{ width: "50%" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "40%", height: "12px", marginBottom: "10px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "41px" }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "70%", height: "12px", marginBottom: "10px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "41px" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div style={{ width: "50%" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "60%", height: "12px", marginBottom: "10px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "41px" }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <IonSkeletonText
                animated={true}
                style={{
                  visibility: "hidden",
                  height: "12px",
                  marginBottom: "10px",
                }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "41px" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div style={{ width: "50%" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "50%", height: "12px", marginBottom: "10px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "41px" }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <IonSkeletonText
                animated={true}
                style={{ width: "50%", height: "12px", marginBottom: "10px" }}
              />
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "41px" }}
              />
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter className="ion-padding ion-no-border">
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "44px", marginBottom: "8px" }}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="6">
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "44px" }}
              />
            </IonCol>
            <IonCol size="6">
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "44px" }}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </>
  );
};

export default Skeleton_OrderViewModal;
